"use strict";

exports.__esModule = true;
var _AlertScreenToolbar = require("./AlertScreenToolbar");
Object.keys(_AlertScreenToolbar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AlertScreenToolbar[key]) return;
  exports[key] = _AlertScreenToolbar[key];
});